import './questionAccordian.scss'
import React, { Fragment } from 'react'
import AnimateHeight from 'react-animate-height'
import i18n from 'i18next'
import GrabIcon from '../../../assets/images/move-icon.svg'

// Used in /presentation
const QuestionAccordian = (props) => {
    const renderQuestionItemFull = () => {
        const {
            question,
            provided,
            show,
            toggle,
            content,
            preview,
            options,
            titleContent,
            oid,
        } = props
        const questionLevel = oid
        const className = (!question.modifiable ? ' locked' : '')

        return (
            <div
                className="question-list-item-presentation"
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
            >
                <div className="question-list-item-header-presentation">
                    <div className={`question-list-item-left-presentation q_${questionLevel}`} />
                    <div className={`question-list-item-right-presentation ${show ? 'expanded' : ''}`}>
                        <div className="question-list-item-right-top-presentation">
                            <img src={GrabIcon} alt="Grab icon" />
                            <div className={`chevron-container ${show ? 'expanded' : ''}`} onClick={toggle}><i className={`fa ${show ? 'fa-chevron-up' : 'fa-chevron-down'}`} aria-hidden="true" /></div>
                            <span className={className}>
                                {titleContent}

                            </span>
                        </div>
                        <div className="question-list-item-right-bottom-presentation">
                            <div className={`question-preview-presentation ${show ? 'expanded' : ''}`}>
                                {
                                    <>
                                        {options()}
                                    </>
                               || (
                                   <>
                                       <i className={`fa-light fa-eye ${show ? 'expanded' : ''}`} />
                                       <span className={show ? 'expanded' : ''}>{i18n.t('sw_preview', 'Preview')}</span>
                                   </>
                               )
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <AnimateHeight
                    duration={250}
                    height={show ? 'auto' : 0}
                    className={show ? 'question-content' : ''}
                >
                    {preview
                            && (
                                <div style={{ padding: 16 }}>
                                    <div style={{ display: 'flex' }}>
                                        {content}
                                    </div>
                                </div>
                            )}
                </AnimateHeight>
            </div>
        )
    }

    return (
        <Fragment>
            {renderQuestionItemFull()}
        </Fragment>
    )
}

export default QuestionAccordian
